import { createTRPCClient, httpBatchLink } from "@trpc/client"
import type { AppRouter } from "@carrot/bff/trpc/router"

// The single browser tRPC client for the BFF. Any workspace package can import this
// rather than constructing its own, so batching and credentials stay coherent across
// the app. `/bff` is a relative same-origin path, so no runtime config is needed.
export const trpc = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: "/bff",
      fetch(url, options) {
        return fetch(url, {
          ...options,
          credentials: "include"
        })
      }
    })
  ]
})

// Debug hook — attach to window everywhere except production so engineers can call
// `await trpc.member.program.query()` from devtools on local dev and preview/stage.
if (typeof window !== "undefined" && window.location.hostname !== "app.get-carrot.com") {
  const debugWindow = window as unknown as { trpc: typeof trpc }
  debugWindow.trpc = trpc
}
